export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/tab_icon_market_hit@2x.png";